import { render } from "./RouterTag.vue?vue&type=template&id=0353a684"
import script from "./RouterTag.vue?vue&type=script&lang=js"
export * from "./RouterTag.vue?vue&type=script&lang=js"

import "./RouterTag.vue?vue&type=style&index=0&id=0353a684&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__